import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import ClientSection from '../components/ClientSection'
import AboutComponent from '../components/AboutComponent'

export default function RenewalsLP() {
  return (
    <div>
      <Header1/>
      <AboutComponent/>
      <ClientSection/>
      <Footer/>
    </div>
  )
}
